import React, { Fragment, useCallback, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "recompose";
import AuthModule from "modules/auth";
import PageTitle from "components/PageTitle";
import CategoryLink from "components/CategoryLink";
import ROUTES from "config/routes";

const SignUp = ({ pagesData, signUpPages }) => {
  useEffect(() => {
    signUpPages();
  }, []);

  const getList = useCallback((list) => {
    return list.map(({ text, url }) => (
      <li key={`${text}${url}`}>
        <Link to={url}>{text}</Link>
      </li>
    ));
  }, []);

  const sections = useMemo(() => {
    if (!pagesData) return null;
    const sections = pagesData.content.sections;

    return sections.map((section) => {
      return (
        <div className="col-12 col-lg-4 d-flex" key={JSON.stringify(section)}>
          <CategoryLink to={section.url} fullCardLink={false}>
            <Fragment>
              <div className="section-title-md text-center category-title">
                {section.title}
              </div>
              <ul>{getList(section.list)}</ul>
            </Fragment>
          </CategoryLink>
        </div>
      );
    });
  }, [getList, pagesData]);

  return (
    <div className="page-body">
      <PageTitle
        align="center"
        title={pagesData?.content?.title}
        isBackButton={true}
      />

      <div className="content-container">
        <div className="container">
          <div className="row">{sections}</div>
        </div>
      </div>
    </div>
  );
};

export default compose(
  connect(
    (state) => ({
      isFetching: state.auth.isFetching,
      isFetched: state.auth.isFetched,
      pagesData: state.auth.pagesData,
    }),
    {
      signUpPages: AuthModule.signUpPages,
    }
  )
)(SignUp);
